export function parseNumeros(numero) {
  return String(numero || '')
    .split(/[,;]+/)
    .map((n) => n.trim().replace(/\s+/g, '').replace(/^\+/, ''))
    .filter(Boolean)
}

export function esNumeroValido(numero) {
  return /^\d{8,15}$/.test(numero)
}

export function getNumerosValidos(numero) {
  return parseNumeros(numero).filter(esNumeroValido)
}

export function resumenDestinatarios(numero) {
  const validos = getNumerosValidos(numero)
  const invalidos = parseNumeros(numero).filter((n) => !esNumeroValido(n))
  return { validos, invalidos, total: validos.length }
}
